<template>
  <div class="d-flex justify-center">
    <v-row
      no-gutters
      style="
        max-width: 1361px;
        height: 753px;
        margin: 3vw 0vw;
        background: #f7f7f7;
      "
      align="center"
      justify="center"
    >
      <v-col>
        <v-row align="center" justify="center"
          ><div :style="headingOneFont" style="color: #00857c">
            Thank you!
          </div></v-row
        >
        <v-row align="center" justify="center" style="margin-top: 1vw">
          <div
            :style="paragraphOneFont"
            style="width: 402px; text-align: center"
          >
            For searching for a clinical trial through Zeda. You will receive an
            email message soon!
          </div></v-row
        >
        <v-row align="center" justify="center" style="margin-top: 2vw">
          <v-img
            max-width="134"
            max-height="147"
            src="@/assets/tick.svg"
          ></v-img>
        </v-row>
        <v-row align="center" justify="center" style="margin-top: 1vw">
          <v-btn
            elevation="2"
            outlined
            color="#00857C"
            plain
            raised
            small
            x-large
            style="text-transform: none; font-family: 'Louis George Café'"
            to="/"
          >
            <img style="padding-right: 4px" src="@/assets/arrow-back-up.svg" />
            Back to Home</v-btn
          >
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  computed: {
    headingOneFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 28px; line-height: 42px; font-weight: 700; font-family: 'Louis George Café';"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 36px; line-height: 46px; font-weight: 700; font-family: 'Louis George Café';"; // Small screens (600px and up)
        case "md":
          return "font-size: 40px; line-height: 50px; font-weight: 700; font-family: 'Louis George Café';"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 44px; line-height: 54px; font-weight: 700; font-family: 'Louis George Café';"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 48px; line-height: 58px; font-weight: 700; font-family: 'Louis George Café';"; // Extra large screens (1904px and up)
        default:
          return "font-size: 48px; line-height: 58px; font-weight: 700; font-family: 'Louis George Café';";
      }
    },
    paragraphOneFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 12px; line-height: 14px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560";
      }
    },
  },
};
</script>

<style scoped>
</style>>
